"use client";

import type { UseOpenApiQueryOptions } from "../../../../request/hooks/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../request/hooks/useOpenApiQuery";
import { keySessionsCount } from "./keySessionsCount";

export type UseRequestSessionsCountProps = Omit<
  UseOpenApiQueryOptions<"/sessions/count">,
  "urlBackendPath"
>;

export const useRequestSessionsCount = ({
  ...props
}: UseRequestSessionsCountProps = {}) => ({
  query: useOpenApiQuery({
    ...props,
    urlBackendPath: "/sessions/count",
    queryKey: keySessionsCount(),
    enabledWithoutSessionToken: true, // Public endpoint
  }),
});
